import { isEmpty } from 'lodash';
import React from 'react';
import useEntity from 'entities/hooks/use-entity';
import { Text, Box } from 'rebass';
import StoriesSection from './components/storiesSection';

const OrganizeStories = ({ firstBookId, structuredStories }) => {
    const type = 'book';
    const { entity: collection } = useEntity({ type, id: firstBookId });

    if (isEmpty(collection)) return false;

    return (
        <Box maxWidth={539} m="auto">
            <Text fontSize="20px" fontFamily="Poppins" fontWeight={400} lineHeight="150%" letterSpacing="-0.4px" my={2} color="#0E0E0E">
                Organize Stories in Chapters
            </Text>
            <Text fontSize="16px" fontFamily="Poppins" fontWeight={400} lineHeight="150%" letterSpacing="-0.32px" mb={3} mt={2} color="#737373">
                Move & order stories in chapters how you want them to appear in your book. You can change this later.
            </Text>
            {structuredStories.filter(({ kind }) => kind !== "system").map((chapter) => (
                <StoriesSection heading={chapter?.name} stories={chapter?.stories} firstBookId={firstBookId} />
            ))}

        </Box>
    );
};

export default OrganizeStories;
